import React from 'react'

// labels
import {LB_COMMENTS} from "../../i18n/i18n";

const WlCardComment = ({comment = ''}) => <div className={'wl-card-comment'}>
    <span className={'wl-label-title'}>{ `${LB_COMMENTS} ` }</span>
    <span className={'wl-label-value'}>{comment}</span>
</div>

export default WlCardComment